
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works-for-consumers",
      function () {
        return require("private-next-pages/how-it-works-for-consumers.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works-for-consumers"])
      });
    }
  